const BLOCKED_RETURN_PATHS = new Set([
    '/',
    '/login',
    '/authenticate',
    '/register',
    '/forgot-password',
    '/confirm-mail',
    '/secure',
    '/setup-2fa',
    '/reset-password',
]);

export const POST_AUTH_RETURN_KEY = 'lens_post_auth_return';

function normalizeReturnPath(path) {
    if (!path || typeof path !== 'string') {
        return null;
    }
    const trimmed = path.trim();
    if (!trimmed) {
        return null;
    }
    const normalized = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    const pathname = normalized.split('?')[0];
    if (!pathname || BLOCKED_RETURN_PATHS.has(pathname)) {
        return null;
    }
    return normalized;
}

export function stashPostAuthReturn(location) {
    if (!location?.pathname || BLOCKED_RETURN_PATHS.has(location.pathname)) {
        return;
    }
    const path = `${location.pathname}${location.search || ''}${location.hash || ''}`;
    sessionStorage.setItem(POST_AUTH_RETURN_KEY, path);
}

export function clearPostAuthReturn() {
    sessionStorage.removeItem(POST_AUTH_RETURN_KEY);
}

export function peekPostAuthReturn() {
    return normalizeReturnPath(sessionStorage.getItem(POST_AUTH_RETURN_KEY));
}

export function buildLoginRedirectPath(location) {
    const path = `${location.pathname}${location.search || ''}${location.hash || ''}`;
    stashPostAuthReturn(location);
    const returnTo = encodeURIComponent(path);
    return `/?returnTo=${returnTo}`;
}

export function buildLoginRedirectUrlFromWindow() {
    if (typeof window === 'undefined') {
        return '/';
    }
    const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const pathname = window.location.pathname;
    if (!pathname || BLOCKED_RETURN_PATHS.has(pathname)) {
        return '/';
    }
    sessionStorage.setItem(POST_AUTH_RETURN_KEY, path);
    return `/?returnTo=${encodeURIComponent(path)}`;
}

export function getReturnPathFromLocation(location) {
    const params = new URLSearchParams(location?.search || '');
    const returnTo = params.get('returnTo');
    if (returnTo) {
        try {
            const decoded = normalizeReturnPath(decodeURIComponent(returnTo));
            if (decoded) {
                return decoded;
            }
        } catch {
            // ignore malformed returnTo
        }
    }

    if (params.get('section')?.toLowerCase() === 'email-preferences') {
        return '/user-settings?section=email-preferences';
    }

    const from = location?.state?.from;
    if (from?.pathname) {
        const fromPath = normalizeReturnPath(`${from.pathname}${from.search || ''}${from.hash || ''}`);
        if (fromPath) {
            return fromPath;
        }
    }

    return peekPostAuthReturn();
}
